// ============================================================================
// @gs/i18n/localeContext — contexte locale LEGER (zero dependance i18next)
// ============================================================================
// Fichier .ts et non .tsx : ce module ne rend AUCUN JSX (createContext +
// useContext). Le garder en .tsx le faisait entrer dans le glob React de
// `npm run lint`, ou react-refresh/only-export-components (allowConstantExport)
// se met a signaler le contexte et le hook des que les constantes cessent
// d'etre des litteraux — ce qui est le cas depuis leur extraction. Renomme le
// 2026-08-26 ; le specificateur d'import '@gs/i18n/localeContext' est INCHANGE.
// Consomme par @gs/ui (GsUserMenu, selecteur Langue) sans tirer i18next dans
// le bundle des apps NON migrees : ce module n'importe que React. Le provider
// reel (GsLocaleProvider, exporte par @gs/i18n racine) branche ce contexte sur
// i18next ; sans provider, useLocale() retourne null et les consommateurs
// masquent leur controle (apps non migrees = aucun controle mort affiche).

import { createContext, useContext } from 'react';

// Le vocabulaire de langue vit dans `./supportedLocales` (ZERO dependance) pour
// que le point d'entree SANS React (`./core`, D10) puisse le nommer sans tirer
// React. Re-exporte ici : l'API publique de ce sous-chemin ne bouge pas.
// Le vocabulaire de langue est DECLARE dans ./supportedLocales (zero import) pour
// que le point d'entree sans React (./core, D10) puisse le nommer sans tirer
// React. Re-exporte ici : l'API publique de '@gs/i18n/localeContext' ne bouge pas.
export { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './supportedLocales';
export type { SupportedLocale } from './supportedLocales';

import type { SupportedLocale } from './supportedLocales';

export interface LocaleContextValue {
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => void;
  /**
   * Applique la langue par defaut de la compagnie (`ug.CompanyBranding.locale`, ADR-088 regle 8) a la
   * reception du branding : seulement si l'usager n'a ni preference ni choix memorise, et sans rien
   * memoriser (contrairement a `setLocale`). Fournie par GsLocaleProvider ; absente sans provider.
   */
  applyCompanyLocale?: (raw: string | null | undefined) => void;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);

/**
 * Locale courante + setter, ou `null` si aucun GsLocaleProvider n'est monte
 * (app non migree i18n) — les consommateurs (GsUserMenu) masquent alors le
 * controle de langue au lieu d'afficher un placeholder mort.
 */
export function useLocale(): LocaleContextValue | null {
  return useContext(LocaleContext);
}
